import Wait from "./Wait.js";
import {formatTime} from "../../assets/common/format-utils.js";

export default class WaitDepartureTime extends Wait {
    constructor(planeId, departureTime) {
        super(planeId, departureTime, 'departure time');
    }
}